import type { Pagination, PaginationResponse } from '@/types'
import maxios from '@/utils/axios/maxios'

// 반 API
const lessonClassApi = {
  // 반 정보 가져오기
  getLessonClass(pageQueryString: string) {
    return maxios.get<PaginationResponse<res.LessonClass[]>>(`/lesson-classes${pageQueryString}`)
  },
  // 반 생성하기
  postLessonClass(data: req.LessonClassDetail) {
    return maxios.post('/lesson-classes', data)
  },
  // 특정 반 정보 변경하기
  patchLessonClass(id: req.LessonClassId, data: req.LessonClassDetail) {
    return maxios.patch(`/lesson-classes/${id}`, data)
  },
  // 반 순서 변경하기
  putLessonClassesOrder(data: req.LessonClassOrder) {
    return maxios.put('/lesson-classes/order', data)
  },
  // 반 삭제하기
  deleteLessonClasses(data: req.LessonClassId[]) {
    return maxios({
      url: '/lesson-classes',
      method: 'DELETE',
      data,
    })
  },
  // 배정된 반이 있는 선생님 가져오기
  getClassAssignedTeachers() {
    return maxios.get<res.ClassAssignedTeacher[]>('/lesson-classes/teachers')
  },
  // 해당 반 정보 가져오기
  getLessonClassById(id: number) {
    return maxios.get<res.LessonClassDetail>(`/lesson-classes/${id}`)
  },
  // 반별 정렬로 학생 출결 가져오기
  getLessonClassesAttendance: (queryString: string) => {
    return maxios.get<PaginationResponse<res.LessonClassesIncludeAttendance[]>>(
      `/lesson-classes/members${queryString}`,
    )
  },
  // 반별 정렬로 학생 핸드폰 번호 가져오기 (TODO: 맞나 확인)
  getLessonClassesPhone: () => {
    return maxios.get<Pagination<res.LessonClassesIncludePhone[]>>(`/lesson-classes/phone`)
  },
}

export default lessonClassApi
